export const FAVORITES_MENU_REQUEST_ADD = '@@favorites/FAVORITES_MENU_REQUEST_ADD';
export const FAVORITES_MENU_REQUEST_REMOVE = '@@favorites/FAVORITES_MENU_REQUEST_REMOVE';
